import { FC, useContext } from 'react';
import { Formik } from 'formik';
import { forEach as lodashForEach, get, isEmpty, isEqual, some } from 'lodash';
import { CbSelect } from '../CbSelect';
import { DateRangeFilter, MultiCheckboxFilter, MultiWithBadges, TableDrawer, TableContext, TableDrawerName, UserSelectFilter } from '.';
import { CbButton } from '../Buttons/CbButton';
import { FilterConfig, FilterType } from 'hooks/useTable';
import styles from './AllFiltersDrawer.module.css';
export const AllFiltersDrawer: FC = () => {
  const {
    clearFilterValues,
    closeDrawer,
    drawerFilterInfo,
    updateFilter
  } = useContext(TableContext);
  const initValues = drawerFilterInfo.reduce((acc, {
    columnId,
    value
  }) => ({
    ...acc,
    [columnId]: value
  }), {});
  const onSubmit = values => {
    lodashForEach(values, (value, columnId) => updateFilter({
      columnId,
      value
    }));
    closeDrawer();
  };
  return <TableDrawer name={TableDrawerName.AllFilters} data-sentry-element="TableDrawer" data-sentry-component="AllFiltersDrawer" data-sentry-source-file="AllFiltersDrawer.tsx">
      <Formik initialValues={initValues} onSubmit={onSubmit} data-sentry-element="Formik" data-sentry-source-file="AllFiltersDrawer.tsx" data-sentry-element="Formik">
        {({
        dirty,
        handleSubmit,
        setFieldValue,
        setValues,
        values
      }) => {
        const clearFilters = () => setValues(clearFilterValues);

        // isEqual can handle comparing empty arrays, etc.
        const clearFilterApplicable = some(clearFilterValues, (value, key) => !isEqual(values[key], value));
        const missingRequiredField = drawerFilterInfo.some(filter => get(filter, 'filterConfig.required', false) && isEmpty(values[filter.columnId]));
        const disableSubmit = !dirty || missingRequiredField;
        return <>
              <div className={styles.allFilters}>
                {drawerFilterInfo.map(filter => {
              const {
                columnId,
                filterConfig
              } = filter as {
                columnId: string;
                filterConfig: FilterConfig;
              };
              if (filterConfig.type === FilterType.DateRange) {
                const handleChange = ({
                  value
                }) => setFieldValue(columnId, value);
                return <DateRangeFilter columnId={columnId} onChange={handleChange} value={values[columnId]} />;
              }
              if (filterConfig.type === FilterType.MultiCheckboxes) {
                const handleChange = (newSelectedArray: string[]) => setFieldValue(columnId, newSelectedArray);
                return <MultiCheckboxFilter columnId={columnId} onChange={handleChange} value={values[columnId]} />;
              }
              if (filterConfig.type === FilterType.MultiWithBadges) {
                const handleChange = (newSelectedArray: string[]) => setFieldValue(columnId, newSelectedArray);
                return <MultiWithBadges allSelectedValues={values[columnId]} columnId={columnId} onChange={handleChange} />;
              }
              if (filterConfig.type === FilterType.UserSelection) {
                const handleChange = (newValue: string) => setFieldValue(columnId, newValue);
                return <UserSelectFilter columnId={columnId} onChange={handleChange} value={values[columnId]} />;
              }
              const {
                options
              } = filterConfig;
              const formattedOptions = options.map(option => ({
                name: option.label,
                value: option.value
              }));
              const handleChange = ({
                value
              }: {
                value: string;
              }) => setFieldValue(columnId, value);
              const selectedOption = formattedOptions.find(opt => opt.value === values[columnId]);
              return <div className={styles.filterComponent}>
                      <span className={styles.filterLabel}>
                        {filter.columnName}
                      </span>
                      <CbSelect className={styles.filterSelect} getValueFromOption={option => option.value} onChange={handleChange} options={formattedOptions} value={selectedOption} />
                    </div>;
            })}
              </div>
              <div className={styles.actions}>
                <div>
                  {clearFilterApplicable && <CbButton onClick={clearFilters} variant="secondary-action">
                      Clear Filters
                    </CbButton>}
                </div>
                <div>
                  <CbButton isDisabled={disableSubmit} onClick={() => handleSubmit()} data-sentry-element="CbButton" data-sentry-source-file="AllFiltersDrawer.tsx" data-sentry-element="CbButton" data-sentry-element="CbButton" data-sentry-element="CbButton" data-sentry-element="CbButton">
                    Apply
                  </CbButton>
                </div>
              </div>
            </>;
      }}
      </Formik>
    </TableDrawer>;
};